import axios from 'axios';
import { apiUrl } from '@qwealth/qdata';

export const complianceApprovalApi = (kycId: number): Promise<void> =>
  axios.post(`${apiUrl}/newkyc/${kycId}/complianceApproval`, {
    isApproved: true
  });
